"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resources = void 0;
var tslib_1 = require("tslib");
var i18next_1 = (0, tslib_1.__importDefault)(require("i18next"));
var ns1_json_1 = (0, tslib_1.__importDefault)(require("./en/ns1.json"));
var ns2_json_1 = (0, tslib_1.__importDefault)(require("./en/ns2.json"));
var products_list_json_1 = (0, tslib_1.__importDefault)(require("./en/products_list.json"));
var forms_json_1 = (0, tslib_1.__importDefault)(require("./en/forms.json"));
var storefront_json_1 = (0, tslib_1.__importDefault)(require("./en/storefront.json"));
var contact_support_json_1 = (0, tslib_1.__importDefault)(require("./en/contact_support.json"));
var custom_event_json_1 = (0, tslib_1.__importDefault)(require("./en/custom_event.json"));
var admin_json_1 = (0, tslib_1.__importDefault)(require("./en/admin.json"));
var react_i18next_1 = require("react-i18next");
exports.resources = {
    en: {
        ns1: ns1_json_1.default,
        ns2: ns2_json_1.default,
        productsList: products_list_json_1.default,
        contactSupport: contact_support_json_1.default,
        customEvent: custom_event_json_1.default,
        forms: forms_json_1.default,
        storefront: storefront_json_1.default,
        admin: admin_json_1.default,
    },
};
i18next_1.default.use(react_i18next_1.initReactI18next).init({
    lng: 'en',
    ns: [
        'ns1',
        'ns2',
        'productsList',
        'contactSupport',
        'customEvemt',
        'forms',
        'storefront',
        'admin',
    ],
    resources: exports.resources,
});
